// removed by extract-text-webpack-plugin
module.exports = {"lineItemQuantity__label":"_1xNIoOo9pp0lAQIPI4vwPM","o-quantity":"wVX78hPomkJriLJ8eOt_X","o-quantity--input":"_1J1-5ZHMx9C63jzHrZMlVY","o-quantity--button":"_1MavOd_olO-CegOiTnsL1b"};


//////////////////
// WEBPACK FOOTER
// ./shared/components/LineItemQuantity/style.scss
// module id = 895
// module chunks = 0